<template>
  <div>
    <div class="container">
      <p>
      <h4> 교재정보</h4>
      <form data-vv-scope="edit">
        <table class="table table-bordered">
          <colgroup>
            <col width="15%" class="bg-lightdark"/>
            <col width="35%"/>
            <col width="15%" class="bg-lightdark"/>
            <col width="35%"/>
          </colgroup>
          <tr>

            <th>교과서명</th>
            <td colspan="4">
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.textbookNm')}"
                     v-model="data.row.textbookNm" placeholder="textbookNm" v-validate="''" name="textbookNm"
              />
              <span v-show="errors.has('edit.textbookNm')" class="invalid-feedback">{{
                  errors.first('edit.textbookNm')
                }}</span>
            </td>
          </tr>
          <tr>
            <th>이미지</th>
            <td>
              <img :src="data.aws_cdn_path+ data.row.textbookImgPath " style="width:200px">
            </td>
            <th >교과서아이디</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.textbookId')}"
                     v-model="data.row.textbookId" placeholder="textbookId" v-validate="''" name="textbookId"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.textbookId')" class="invalid-feedback">{{
                  errors.first('edit.textbookId')
                }}</span>
            </td>
          </tr>
          <tr>
            <th>ISBN</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.isbnCd')}"
                     v-model="data.row.isbnCd" placeholder="isbnCd" v-validate="''" name="isbnCd"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.isbnCd')" class="invalid-feedback">{{
                  errors.first('edit.isbnCd')
                }}</span>
            </td>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.isbnCd')}"
                     v-model="data.row.isbn" placeholder="isbnCd" v-validate="''" name="isbnCd"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.isbnCd')" class="invalid-feedback">{{
                  errors.first('edit.isbnCd')
                }}</span>
            </td>
            <th>개정년도</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.rvsnYear')}"
                     v-model="data.row.rvsnYear" placeholder="rvsnYear" v-validate="''" name="rvsnYear"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.rvsnYear')" class="invalid-feedback">{{
                  errors.first('edit.rvsnYear')
                }}</span>
            </td>
          </tr>
          <tr>
            <th>저자</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.author')}"
                     v-model="data.row.author" placeholder="author" v-validate="''" name="author"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.author')" class="invalid-feedback">{{
                  errors.first('edit.author')
                }}</span>
            </td>
            <th>과목유형
            </th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.subjectTypeNm')}"
                     v-model="data.row.subjectTypeNm" placeholder="subjectTypeNm" v-validate="''" name="subjectTypeNm"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.subjectTypeNm')"
                    class="invalid-feedback">{{ errors.first('edit.subjectTypeNm') }}</span>
            </td>
          </tr>
          <tr>
            <th>과목명</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.subjectNm')}"
                     v-model="data.row.subjectNm" placeholder="subjectNm" v-validate="''" name="subjectNm"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.subjectNm')" class="invalid-feedback">{{
                  errors.first('edit.subjectNm')
                }}</span>
            </td>
            <th>출판사</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.pubComp')}"
                     v-model="data.row.pubComp" placeholder="pubComp" v-validate="''" name="pubComp"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.pubComp')" class="invalid-feedback">{{
                  errors.first('edit.pubComp')
                }}</span>
            </td>
          </tr>

          <tr>
            <th>소개문</th>
            <td colspan="4">
                  <textarea :class="{'form-control':true, 'is-invalid': errors.has('edit.notice')}"
                            v-model="data.row.notice" placeholder="notice" v-validate="''" name="notice"
                            style="height:200px"/>
              <span v-show="errors.has('edit.notice')" class="invalid-feedback">{{
                  errors.first('edit.notice')
                }}</span>
            </td>
          </tr>
          <tr>
            <th>키워드</th>
            <td colspan="4">
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.keyWord')}"
                     v-model="data.row.keyWord" placeholder="keyWord" v-validate="''" name="keyWord"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.keyWord')" class="invalid-feedback">{{
                  errors.first('edit.keyWord')
                }}</span>
            </td>


          </tr>

          <tr>
            <th>승인상태</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.apprStatCd')}"
                     v-model="data.row.apprStatCd" placeholder="apprStatCd" v-validate="''" name="apprStatCd"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.apprStatCd')" class="invalid-feedback">{{
                  errors.first('edit.apprStatCd')
                }}</span>
            </td>
            <th>전시상태</th>
            <td>
              <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.openStatCd')}"
                     v-model="data.row.openStatCd" placeholder="openStatCd" v-validate="''" name="openStatCd"
                     style="width: 200px"/>
              <span v-show="errors.has('edit.openStatCd')" class="invalid-feedback">{{
                  errors.first('edit.openStatCd')
                }}</span>
            </td>
          </tr>


        </table>
      </form>
    </div>

    <div class="container">
      <p>
      <h4> 단원 세부자료 정보</h4>
      <YcloudTextbookAtrbRelInfoList :bookId="bookId" :key="data.row.textbookId"/>
    </div>

  </div>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getTextbookMstList, getTextbookMstItem, saveTextbookMst, deleteTextbookMst} from "@/api/ext/TextbookMstApi";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, aws_cdn_path} from "@/utils/Constants";
import YcloudTextbookAtrbRelInfoList from "./YcloudTextbookAtrbRelInfoList"
export default {
  components: {YcloudTextbookAtrbRelInfoList},
  props: {
    bookId: '',
    data:{},
  },
  setup(props) {

  },
}


</script>